export const thi_date = (t) => {
  const tt = new Date(t);
  const day = tt.getDate().toString().padStart(2, '0');
  const month = (tt.getMonth() + 1).toString().padStart(2, '0');
  const year = tt.getFullYear();
  return `${day}/${month}/${year}`;
};

export const thi_timestamp = (strDate) => {
  const dt = Date.parse(strDate);
  return dt / 1000;
};
